import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-[#E85D04] border-t-transparent rounded-full animate-spin"></div>
          <p className="text-[#73706A]">Carregando...</p>
        </div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admin-only pages: redirect regular users to portal
  const adminPages = ['/dashboard', '/students', '/payments', '/classes', '/courts', '/events', '/store', '/trial-classes', '/notifications', '/subscriptions', '/settings'];
  const isAdminPage = adminPages.some(p => location.pathname.startsWith(p));
  
  if (isAdminPage && user.role !== 'admin') {
    return <Navigate to="/portal" replace />;
  }

  return children;
}
